import { ReactNode } from 'react';
import { SVGProps } from 'react';
import type { Size } from '@blockanalitica/ui/package/types/src/theme/types';
import { resolveThemeVariable } from '@blockanalitica/ui';
import { useTheme } from 'styled-components';

export interface SvgProps extends SVGProps<SVGSVGElement> {
  size?: Size | string | number;
}

export default function Svg({
  size = '0',
  children,
  ...rest
}: SvgProps & { children: ReactNode }) {
  const theme = useTheme();
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={
        typeof size === 'number'
          ? size + 'px'
          : resolveThemeVariable<Size | string>(size, theme.sizes)
      }
      height={
        typeof size === 'number'
          ? size + 'px'
          : resolveThemeVariable<Size | string>(size, theme.sizes)
      }
      {...rest}>
      {children}
    </svg>
  );
}
